<template>
  <div>
    <template v-if="!selectedCustomer">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <input ref="search" type="text" class="form-control" :placeholder="searchPlaceholder" v-model="search" /> 
          </div>
        </div>
      </div>
      <div class="row" v-if="searching">
        <div class="col-xs-12">
          <div class="well">
            <i class="fa fa-fw fa-cog fa-spin"></i> {{ _('Loading...') }}
          </div>
        </div>
      </div>
      <div class="row" v-if="noResults">
        <div class="col-xs-12">
          <div class="well">
            {{ _('No results found.') }}
          </div>
        </div>
      </div>
      <customer-item v-for="c in customers" :customer="c" :key="c.id" :selected="false" :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" v-on:selectCustomer="selectCustomer" />
      <button class="btn btn-default" v-on:click="createNew"><i class="fa fa-fw fa-plus"></i> {{ _('Create new client') }}</button>
    </template>
    <customer-item v-else :customer="selectedCustomer" :selected="true" :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" v-on:selectCustomer="selectCustomer" />
  </div>
</template>

<script>

import events from '~/lib/events'
import modals from '~/lib/modals'
import { ModalCustomerDetails as CustomerDetails, CustomerItem } from '#components'
import customersearch from '~/lib/customersearch'
import axios from 'axios'
import debounce from 'lodash/debounce'

export default {
  props: ['baseDomain', 'shopId', 'apiKey', 'skipFocus'],
  mixins: [customersearch, events, modals],
  data () {
    return {
      customers: [],
      updatedWhileCreating: [],
      creatingNew: false,
      column: {
        identifier: 'customersearch',
        component: {
          id: 1
        }
      },
      newCustomerId: null
    }
  },
  computed: {
    searchPlaceholder () {
      return this._('Find a client (name, phone, email)')
    },
    noResults () {
      if (!this.searching && (!this.customers || !this.customers.length) && this.search && this.search.length >= this.minLength) {
        return true
      }
      return false
    }
  },
  methods: {
    createNew () {
      this.creatingNew = true
      this.updatedWhileCreating = []
      this.showModal('customerdetails', CustomerDetails, {
        props: {
          baseDomain: this.baseDomain,
          shopId: this.shopId,
          apiKey: this.apiKey,
          component: {
            initData: {
              customer: {
                name: this.search,
                country: 'FI'
              },
              modal: true
            }
          }
        },
        events: {
          save: this.customerCreated
        },
        handlers: {},
        width: 1000
      })
      return
    },
    customerCreated (customer) {
      this.creatingNew = false
      if (customer) {
        this.newCustomerId = parseInt(customer.id, 10)
        if (this.updatedWhileCreating.includes(this.newCustomerId)) {
          this.loadAndSelectCustomer(this.newCustomerId)       
        }
      }
    },
    async loadAndSelectCustomer (id) {
      this.selectedCustomer = await this.loadCustomer(id)
      this.$emit('selectCustomer', this.selectedCustomer)
    },
    clearSearch () {
      this.customers = []
    },
    doSearch: debounce(async ($this) => {
      $this.searching = true
      $this.customers = await $this.searchCustomers($this.search)
      $this.searching = false
    }, 250),
    loadCustomer (id) {
      return new Promise(async (resolve, reject) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/customers/' + id + '.json?apikey=' + this.apiKey)
        } catch (e) {
          resolve(null)
          return
        }
        resolve(response.data)
      })
    }
  },
  components: {
    CustomerItem
  },
  async mounted () {
    if(!this.events) {
      let events = {}
      events['customerUpdate'] = async (message) => {
        if (!message || !message.data) {
          return
        }
        const id = parseInt(message.data.id, 10)
        if (this.selectedCustomer && parseInt(this.selectedCustomer.id, 10) === id) {
          this.selectedCustomer = await this.loadCustomer(id)
        }
        if (this.newCustomerId === id) {
          this.selectedCustomer = await this.loadCustomer(id)
          this.$emit('selectCustomer', this.selectedCustomer)
        }
        if(this.creatingNew) {
          this.updatedWhileCreating.push(id)
        }
        const foundIndex = this.customers.findIndex(c => parseInt(c.id, 10) === id)
        if (foundIndex !== -1) {
          const customer = await this.loadCustomer(id)
          if (customer) {
            this.customers[foundIndex] = customer
          }
        }
      }
      this.events = events
    }
    this.enableEventBus()
  }
}
</script>